import { call, select } from 'redux-saga/effects';

import * as GTMConstants from '../constants';
import * as D from '../deps';
import * as Services from '../services';

export function* getCommonData() {
  return {
    [GTMConstants.Variables.OS_NAME]: yield select(D.Utils.ClientInfo.getOSName),
    [GTMConstants.Variables.LID]: yield select(D.Utils.Listener.getListenerPublicLid),
    [GTMConstants.Variables.ZIP_CODE]: yield select(D.Utils.Listener.getCurrentUserZipCode),
    [GTMConstants.Variables.TIER]: yield select(D.Selectors.Payments.getActiveProductGroupTier),
    [GTMConstants.Variables.DISCOUNT_TYPE]: yield select(
      D.Selectors.Payments.getActiveProductDiscountType,
    ),
    [GTMConstants.Variables.IS_TRIAL]: yield select(D.Selectors.Payments.getInPaymentBackedTrial),
    [GTMConstants.Variables.DURATION_TYPE]: yield select(
      D.Selectors.Payments.getActiveProductDurationType,
    ),
    [GTMConstants.Variables.DURATION_TIME]: yield select(
      D.Selectors.Payments.getActiveProductDurationTime,
    ),
    [GTMConstants.Variables.TIMES_RENEWABLE]: yield select(
      D.Selectors.Payments.getActiveProductTimesRenewable,
    ),
  };
}

export function* pushData(eventData) {
  const commonData = yield call(getCommonData);
  yield call(Services.pushData, Object.assign({}, commonData, eventData));
}

export function* pushEvent(eventName, data = {}) {
  yield call(pushData, { [GTMConstants.Variables.EVENT]: eventName, ...data });
}

export function* pushUpgradeEvent(eventName, { tier, discountType, isTrial }) {
  yield call(pushEvent, eventName, {
    [GTMConstants.Variables.SELECTED_TIER]: tier,
    [GTMConstants.Variables.SELECTED_DISCOUNT_TYPE]: discountType,
    [GTMConstants.Variables.SELECTED_IS_TRIAL]: isTrial,
  });
}
